import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import env from '../environment';
import { getManagerNameSorter, getFloatingTaskSorter } from '../utils/sorting';
import roles from '../utils/roles';
import { browserHistory } from 'react-router';

import FloatingTaskEditor from './FloatingTaskEditor';
import FloatingTaskPill from './FloatingTaskPill';
import Spinner from './Spinner';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import taskActions from '../actions/taskActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';
import projectActions from '../actions/projectActionCreators';
import userActions from '../actions/userActionCreators';

require.ensure([], () => {
    require('./PMO.less');
});

class FloatingTasks extends React.Component {

    constructor(props, context) {
        super(props, context);

        props.dispatch(userActions.loadPms());

        this.state = {
            activeManager: this.props.currentUser ? this.props.currentUser.givenName + " " + this.props.currentUser.surname : "Unassigned",
            activeTask: null,
            showEdit: false,
            backgroundDataLoaded: false
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if (!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO', 'LM', 'PM'])) {
                browserHistory.push('/');
            }
        }
    }

    componentDidUpdate = (prevProps) => {
        if (!this.state.backgroundDataLoaded) {
            const loadingCompleted = prevProps.loading && !this.props.loading;
            const dataAlreadyAvailable = this.props.floatingTasks.length > 0;

            if (loadingCompleted || dataAlreadyAvailable) {
                this.loadData();
                this.setState({
                    backgroundDataLoaded: true
                });
            }
        }
    }

    componentDidMount = () => {
        let queryParams = this.props.routeParams;
        if (queryParams.task) {

            let activeTaskID = env.tashi + '/floatingTasks/' + queryParams.task;

            let activeTask = null;
            for (let i = 0; i < this.props.floatingTasks.length; i++) {
                if (this.props.floatingTasks[i].id === activeTaskID) {
                    activeTask = this.props.floatingTasks[i];
                    break;
                }
            }

            let activeManager = "Unassigned";
            if (queryParams.manager) {
                let activeManagerId = env.tashi + '/users/' + queryParams.manager;
                for (let i = 0; i < this.props.pmUsers.length; i++) {
                    if (this.props.pmUsers[i].id === activeManagerId) {
                        activeManager = this.props.pmUsers[i].givenName + ' ' + this.props.pmUsers[i].surname;
                        break;
                    }
                }
            }

            this.setState({
                activeManager: activeManager,
                activeTask: activeTask
            });
        }
    }

    // EVENT HANDLERS

    handleDelete = () => {
        this.props.dispatch(floatingTaskActions.pmoDelete(this.state.activeTask.id));
        this.setState({
            activeTask: null,
            showEdit: false
        });
    }

    handleManagerClick = (managerName) => {
        this.setState({
            activeManager: this.state.activeManager === managerName ? "" : managerName
        });
    }

    handleRefresh = () => {
        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
            this.props.dispatch(floatingTaskActions.pmoLoadAll());
        } else if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
            this.props.dispatch(floatingTaskActions.pmLoadAll());
        }
    }

    handleReturn = (message) => {
        this.props.dispatch(floatingTaskActions.returnToUser(this.state.activeTask, message));
        this.setState({
            activeTask: null,
            showEdit: false
        });
    }

    handleTaskClick = (task) => {
        this.props.dispatch(logEntryActions.loadByTask(task.id));

        this.setState({
            activeTask: task === this.state.activeTask ? null : task,
            showEdit: task !== this.state.activeTask
        });
    }

    // OTHER METHODS

    loadData = () => {
        // Load projects and tasks in background (floating tasks loaded via handleRefresh)
        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
            this.props.dispatch(projectActions.pmoLoadAll());
            this.props.dispatch(taskActions.pmoLoadAll());
        } else if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
            this.props.dispatch(projectActions.pmLoadAll());
            this.props.dispatch(projectActions.pmLoadAllWithoutTasks());
            this.props.dispatch(taskActions.pmLoadAll());
        }
    }

    // RENDER METHOD

    render = () => {
        if (!this.props.loading && this.props.floatingTasks.length == 0) {
            return (
                <div className="container">
                    <br /><h4 className="text-center">There are no floating tasks to resolve</h4>
                </div>
            );
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-lg-offset-2">
                        <div className="project floating-manage">
                            <h3>Floating Tasks</h3>
                            <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                {
                                    this.props.loading
                                        ? <Spinner />
                                        : <div className="form-horizontal">
                                            {
                                                this.props.managerNames.map((name, outerKey) => {
                                                    if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
                                                        return (
                                                            <div className="panel panel-default panel-pmproject" key={outerKey}>
                                                                <div className="panel-heading" role="tab" id="headingThree-outer">
                                                                    <h4 className="panel-title" style={{ backgroundColor: "#AAA" }}>
                                                                        <a style={{ "cursor": "pointer" }} onClick={() => this.handleManagerClick(name)} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                                                            <span className="acc"><span className={name === this.state.activeManager ? "md-expand-more" : "md-chevron-right"} /></span>
                                                                            {name}
                                                                            <span className="pull-right label">{this.props.managerMap[name].floatingTasks.length}</span>
                                                                        </a>
                                                                    </h4>
                                                                </div>
                                                                <div id="collapseThree-outer" className={name === this.state.activeManager ? "panel-collapse" : "panel-collapse collapse"} role="tabpanel" aria-labelledby="headingThree">
                                                                    <div className="panel-body">
                                                                        {
                                                                            this.props.managerMap[name].floatingTasks.map((floatingTask, key) => {
                                                                                if (floatingTask.returned) {
                                                                                    return null;
                                                                                }

                                                                                if (this.state.activeTask && floatingTask.id === this.state.activeTask.id) {
                                                                                    return <FloatingTaskEditor
                                                                                        handleClick={this.handleTaskClick}
                                                                                        handleDelete={this.handleDelete}
                                                                                        handleRefresh={this.handleRefresh}
                                                                                        handleReturn={this.handleReturn}
                                                                                        id={key}
                                                                                        key={key}
                                                                                        managerName={this.state.activeTask.managerName}
                                                                                        overtimeSpent={this.state.activeTask.overtimeSpent}
                                                                                        pmUsers={this.props.pmUsers}
                                                                                        isPmo={roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])}
                                                                                        projects={this.props.projects}
                                                                                        task={this.state.activeTask}
                                                                                        tasks={this.props.tasks}
                                                                                        tasksLoading={this.props.tasksLoading}
                                                                                        timeSpent={this.state.activeTask.timeSpent}
                                                                                    />;
                                                                                }

                                                                                return <FloatingTaskPill
                                                                                    floatingTask={floatingTask}
                                                                                    handleClick={this.handleTaskClick}
                                                                                    id={key}
                                                                                    key={key}
                                                                                    text={floatingTask.name}
                                                                                />;
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    } else {
                                                        return this.props.managerMap[name].floatingTasks.map((floatingTask, key) => {
                                                            if (floatingTask.returned) {
                                                                return null;
                                                            }

                                                            if (this.state.activeTask && floatingTask.id === this.state.activeTask.id) {
                                                                return <FloatingTaskEditor
                                                                    handleClick={this.handleTaskClick}
                                                                    handleDelete={this.handleDelete}
                                                                    handleRefresh={this.handleRefresh}
                                                                    handleReturn={this.handleReturn}
                                                                    id={key}
                                                                    key={key}
                                                                    manager={this.state.activeTask.managerName}
                                                                    overtimeSpent={this.state.activeTask.overtimeSpent}
                                                                    isPmo={roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])}
                                                                    pmUsers={this.props.pmUsers}
                                                                    projects={this.props.projects}
                                                                    task={this.state.activeTask}
                                                                    tasks={this.props.tasks}
                                                                    tasksLoading={this.props.tasksLoading}
                                                                    timeSpent={this.state.activeTask.timeSpent}
                                                                />;
                                                            }

                                                            return <FloatingTaskPill
                                                                floatingTask={floatingTask}
                                                                handleClick={this.handleTaskClick}
                                                                id={key}
                                                                key={key}
                                                                text={floatingTask.name}
                                                            />;
                                                        });
                                                    }
                                                })
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

FloatingTasks.contextTypes = {
    router: PropTypes.object.isRequired
};

FloatingTasks.propTypes = {
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    floatingTasks: PropTypes.array,
    loading: PropTypes.bool,
    managerNames: PropTypes.array,
    managerMap: PropTypes.object,
    pmUsers: PropTypes.array,
    projects: PropTypes.array,
    routeParams: PropTypes.object
};

const mapStateToProps = (state) => {
    let floatingTasks = state.floatingTasks.adminFloatingTasks;

    let managerNames = [];
    let managerMap = {};

    for (let i = 0; i < floatingTasks.length; i++) {
        if (floatingTasks[i].returned) {
            floatingTasks.splice(i, 1);
            i--;
            continue;
        }

        let managerName = floatingTasks[i].managerName ? floatingTasks[i].managerName : "Unassigned";

        // TODO move to util
        let _listContainsString = (list, string) => {
            for (let i = list.length - 1; i >= 0; --i) {
                if (list[i] === string) {
                    return true;
                }
            }
            return false;
        };

        if (!_listContainsString(managerNames, managerName)) {
            managerNames.push(managerName);
            let mapEntry = {
                floatingTasks: []
            };
            mapEntry.floatingTasks.push(floatingTasks[i]);
            managerMap[managerName] = mapEntry;
        } else {
            managerMap[managerName].floatingTasks.push(floatingTasks[i]);
        }
    }

    let currentUser = state.users.currentUser;

    if (currentUser) {
        let currentUserName = currentUser.givenName + " " + currentUser.surname;
        managerNames.sort(getManagerNameSorter(currentUserName));
    }

    for (let i = 0; i < managerNames.length; i++) {
        managerMap[managerNames[i]].floatingTasks.sort(getFloatingTaskSorter(currentUser));
    }

    /*floatingTasks.sort(getFloatingTaskSorter(currentUser));*/

    let projects = state.projects.allProjects.concat(state.projects.allProjectsWithoutTasks)
        .filter(e => e.archived === false);

    return {
        currentUser: state.users.currentUser,
        floatingTasks: floatingTasks,
        loading: state.floatingTasks.loading,
        managerNames: managerNames,
        managerMap: managerMap,
        pmUsers: state.users.roleFilteredUsers,
        projects,
        tasks: state.tasks.allTasks,
        tasksLoading: state.tasks.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FloatingTasks);



/** WEBPACK FOOTER **
 ** ./src/app/components/FloatingTasks.js
 **/